import { useCallback, useEffect } from 'react';
import { adminService } from '../../../services/adminService';
import { useSnackbar } from '../../../components/common/Snackbar';

/**
 * Hook to manage user data fetching for Users page
 * @param {Object} params - Hook parameters
 * @param {number} params.page - Current page
 * @param {number} params.rowsPerPage - Rows per page
 * @param {Function} params.setUsers - Setter for users
 * @param {Function} params.setTotalUsers - Setter for total users
 * @param {Function} params.setLoading - Setter for loading state
 * @returns {Function} Fetch users function
 */
export const useUsersData = ({
  page,
  rowsPerPage,
  setUsers,
  setTotalUsers,
  setLoading,
}) => {
  const { showSnackbar } = useSnackbar();

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const { users: fetchedUsers = [], pagination } = await adminService.getUsers({
        page: page + 1,
        limit: rowsPerPage,
      });

      setUsers(fetchedUsers);
      setTotalUsers(pagination?.total ?? fetchedUsers.length);
    } catch (error) {
      // console.error('Failed to fetch users:', error);
      const message = error.response?.data?.message || 'Failed to fetch users';
      showSnackbar(message, 'error');
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, setUsers, setTotalUsers, setLoading, showSnackbar]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return {
    fetchUsers,
  };
};

